import script from "./RegistrationInquiryDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationInquiryDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationInquiryDetailPage.vue?vue&type=style&index=0&id=7ae5c6ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae5c6ba"]])

export default __exports__